/**
 * Local data events the sync layer listens to. Storage / autosave call these without
 * importing the sync engine (no cycles, and guest mode stays network-free).
 */
type Fn = (id: string) => void;
const saved = new Set<Fn>();
const created = new Set<Fn>();
const deleted = new Set<Fn>();

function emit(set: Set<Fn>, id: string): void {
  for (const f of set) f(id);
}

export const syncHooks = {
  projectSaved: (id: string) => emit(saved, id),
  projectCreated: (id: string) => emit(created, id),
  projectDeleted: (id: string) => emit(deleted, id),
  on(event: 'saved' | 'created' | 'deleted', fn: Fn): () => void {
    const set = event === 'saved' ? saved : event === 'created' ? created : deleted;
    set.add(fn);
    return () => set.delete(fn);
  },
};
